import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
const speakers = [{
  name: 'Dr. María Castellanos',
  location: 'Buenos Aires, Argentina',
  specialty: 'Dermatology & Immunology',
  image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&h=400&fit=crop'
}, {
  name: 'Prof. Klaus Hoffmann',
  location: 'Berlin, Germany',
  specialty: 'Clinical Dermatology',
  image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=400&fit=crop'
}, {
  name: 'Dr. Yuki Tanaka',
  location: 'Tokyo, Japan',
  specialty: 'Atopic Dermatitis Research',
  image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&h=400&fit=crop'
}, {
  name: 'Dr. Sarah Mitchell',
  location: 'London, United Kingdom',
  specialty: 'Pediatric Dermatology',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop'
}, {
  name: 'Prof. James Anderson',
  location: 'Boston, USA',
  specialty: 'Biologic Therapeutics',
  image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=400&h=400&fit=crop'
}, {
  name: 'Dr. Lars Nielsen',
  location: 'Copenhagen, Denmark',
  specialty: 'Inflammatory Skin Disease',
  image: 'https://images.unsplash.com/photo-1537368910025-700350fe46c7?w=400&h=400&fit=crop'
}];
export function LayerHollywood() {
  return <section className="py-24 bg-gradient-to-b from-slate-950 to-slate-900" data-id="element-84">
      <div className="max-w-7xl mx-auto px-6" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-86">
          <div className="flex items-center gap-3 mb-4" data-id="element-87">
            <div className="bg-red-600 text-white px-4 py-1 rounded-full text-sm font-semibold" data-id="element-88">
              LAYER 1
            </div>
            <Sparkles className="w-5 h-5 text-red-600" data-id="element-89" />
          </div>
          <h2 className="font-editorial text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-90">
            The Hollywood Intro
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl" data-id="element-91">
            A cinematic teaser introducing the 6 KOLs like a Netflix
            master-class — building anticipation, credibility, and speaker
            recognition from the first frame.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-92">
          {speakers.map((speaker, index) => <motion.div key={speaker.name} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          scale: 1.05
        }} className="group relative overflow-hidden rounded-2xl bg-slate-800 border border-slate-700 cursor-pointer" data-id="element-93">
              <div className="aspect-[3/4] relative overflow-hidden" data-id="element-94">
                <img src={speaker.image} alt={speaker.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-95" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/60 to-transparent" data-id="element-96" />
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-97">
                <motion.div initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1 + 0.3
            }} data-id="element-98">
                  <h3 className="font-editorial text-2xl font-bold text-white mb-2" data-id="element-99">
                    {speaker.name}
                  </h3>
                  <p className="text-red-400 text-sm font-medium mb-1" data-id="element-100">
                    {speaker.specialty}
                  </p>
                  <p className="text-slate-400 text-sm" data-id="element-101">{speaker.location}</p>
                </motion.div>
              </div>

              {/* Hover overlay */}
              <div className="absolute inset-0 bg-red-600/0 group-hover:bg-red-600/10 transition-colors duration-300" data-id="element-102" />
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="text-center text-slate-400 mt-12 italic" data-id="element-103">
          "Oh, it's Dr. Castellanos from Argentina — she's brilliant"
        </motion.p>
      </div>
    </section>;
}